import { render } from "./Salle9Fr.vue?vue&type=template&id=531996f1"
import script from "./Salle9Fr.vue?vue&type=script&lang=js"
export * from "./Salle9Fr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__